import React, { useEffect, useState, useCallback } from "react";

// MUI
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton"
import { useTheme, useMediaQuery, TypographyProps } from "@mui/material";

// MUI Icons
import LanguageIcon from "@mui/icons-material/Language"
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";

type GeoURIProps = {
  coords4326: number[]
  display?: string
} & TypographyProps

function GeoURI(props: GeoURIProps) {

  const theme = useTheme();
  const isMobile: boolean = useMediaQuery(theme.breakpoints.down("md"));

  const [coordsCopied, setCoordsCopied] = useState(false);

  const { coords4326, display, ...typographyProps } = props;

  const lat = parseFloat(coords4326[1].toFixed(7));
  const lon = parseFloat(coords4326[0].toFixed(7));

  const displayText = display ? display : `${lat}N ${lon}E`;
  const geoUri = `geo:${lat},${lon}`;

  const handleCopyCoordinates =  useCallback(() => {
    navigator.clipboard.writeText(displayText);
    setCoordsCopied(true);
    setTimeout(() => setCoordsCopied(false), 2000);
  }, [displayText]);

  useEffect(() => {
    setCoordsCopied(false);
  }, [coords4326])

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography variant="h5" component="h2" {...typographyProps}>
        {displayText}
      </Typography>
      {isMobile ? (
        <IconButton size="small" color="primary" onClick={() => window.open(geoUri, "_blank")}>
          <LanguageIcon fontSize="small"/>
        </IconButton>
      ) :
        <IconButton size="small" color="primary" onClick={handleCopyCoordinates} disabled={coordsCopied} >
          {coordsCopied ? (
            <CheckIcon fontSize="small" sx={{ color: "green" }} />
          ) : (
            <ContentCopyIcon fontSize="small"/>
          )}
        </IconButton>}
    </Stack>
  );
}

export default GeoURI;
